import { Trash2 } from "lucide-react";
import type { ChangeEvent } from "react";
import { Button } from "@/components/ui/button";
import { TextInput } from "@/components/ui/textInput";

export type NoteSchema = { id?: string; custom_name_of_note?: string; custom_note?: string };

interface NoteComponentProps {
  index: number;
  data: NoteSchema;
  onChange: (index: number, data: NoteSchema) => void;
  onDelete: (index: number) => void;
}

export function NoteComponent({ index, data, onChange, onDelete }: NoteComponentProps) {
  const handleChange = (key: keyof NoteSchema, value: string) => {
    onChange(index, { ...data, [key]: value });
  };

  const handleDelete = () => {
    onDelete(index);
  };

  return (
    <div className="my-4 rounded-lg border border-gray-200 bg-white p-4">
      <div className="flex items-center justify-between gap-3">
        <span className="text-sm font-semibold text-gray-700">Note {index + 1}</span>
        <Button
          variant="outline"
          size="icon"
          type="button"
          onClick={handleDelete}
          aria-label="Delete note"
          title="Delete note"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
      <div className="mt-3 grid grid-cols-1 gap-3 md:grid-cols-2 md:items-end">
        <TextInput
          label="Note"
          value={data.custom_note ?? ""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange("custom_note", e.target.value)}
        />
        <TextInput
          label="Name of note"
          value={data.custom_name_of_note ?? ""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange("custom_name_of_note", e.target.value)}
        />
      </div>
    </div>
  );
}
